import React from "react";
import { ArrowRight, FileText, Microscope, ArrowUpRight } from "lucide-react";
import { research, publications, presentations } from "../mock";
import Reveal from "./Reveal";

const Research = () => {
  return (
    <section id="research" className="bg-white">
      <div className="max-w-5xl mx-auto px-4 py-20">
        <Reveal className="text-center mb-12">
          <span className="text-xs font-bold tracking-[0.3em] uppercase text-gold">Academic Work</span>
          <h2 className="font-head text-3xl sm:text-4xl uppercase tracking-wide text-navy mt-2">Research & Publications</h2>
          <div className="w-16 h-0.5 bg-gold mx-auto mt-4" />
        </Reveal>

        <Reveal>
          <div className="grid md:grid-cols-5 gap-0 rounded-2xl overflow-hidden shadow-lg border border-black/5">
            {/* graphic */}
            <div className="md:col-span-2 bg-navy flex items-center justify-center p-10 relative overflow-hidden">
              <div className="absolute inset-0" style={{ background: "radial-gradient(circle at 30% 30%, rgba(191,157,87,0.18), transparent 60%)" }} />
              <Microscope className="w-28 h-28 text-gold/80 relative" strokeWidth={1} />
            </div>
            {/* content */}
            <div className="md:col-span-3 bg-cream p-8 sm:p-10">
              <span className="inline-flex items-center gap-2 text-[11px] font-bold tracking-[0.25em] uppercase text-gold">
                <FileText className="w-3.5 h-3.5" /> {research.tag}
              </span>
              <h3 className="font-head text-2xl sm:text-3xl uppercase tracking-wide text-navy mt-3 leading-tight">{research.title}</h3>
              <p className="text-navy font-semibold mt-4">{research.authors} <span className="text-gold">{"\u00b7 " + research.year}</span></p>
              <p className="text-sm text-gray-600 italic mt-1">{research.journal}</p>
              <a href={research.url} target="_blank" rel="noopener noreferrer" className="group mt-6 inline-flex items-center gap-2 bg-navy hover:bg-navy-3 text-white text-xs font-bold tracking-[0.2em] uppercase px-6 py-3 transition-colors">
                {research.cta} <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
              </a>
            </div>
          </div>
        </Reveal>

        {/* Selected publications */}
        <Reveal className="mt-12">
          <h3 className="font-head text-xl uppercase tracking-wide text-navy mb-5">Selected Publications</h3>
          <div className="space-y-3">
            {publications.map((p, i) => (
              <div key={i} className="group flex items-start gap-4 bg-cream rounded-xl border border-black/5 px-5 py-4 transition-all duration-300 hover:shadow-md hover:-translate-y-0.5">
                <span className="w-8 h-8 rounded-lg bg-navy text-gold flex items-center justify-center shrink-0 font-head font-bold text-sm">{i + 1}</span>
                <div>
                  <p className="font-semibold text-navy leading-snug">{p.title}</p>
                  <p className="text-sm text-gray-600 mt-1">
                    {p.authors + " \u00b7 "}<span className="italic">{p.journal}</span>{" \u00b7 " + p.year}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </Reveal>

        {/* Presentations */}
        <Reveal className="mt-10">
          <h3 className="font-head text-xl uppercase tracking-wide text-navy mb-4">Presentations & Contributions</h3>
          <ul className="space-y-2">
            {presentations.map((pr) => (
              <li key={pr} className="flex items-start gap-3 text-sm text-gray-700">
                <ArrowUpRight className="w-4 h-4 text-gold mt-0.5 shrink-0" /> {pr}
              </li>
            ))}
          </ul>
        </Reveal>
      </div>
    </section>
  );
};

export default Research;
